import React from 'react';
import { Badge } from 'reactstrap';
import { ContainerLocationStatus } from '@/utils/containerLocation';
import i18n from '@/utils/i18n';

const getContainerLocationStatusColor = (
  status: ContainerLocationStatus,
): string => {
  switch (status) {
    case ContainerLocationStatus.InStock:
      return 'success';
    case ContainerLocationStatus.CheckedOut:
      return 'primary';
    case ContainerLocationStatus.Completed:
      return 'success';
    case ContainerLocationStatus.Recovered:
    case ContainerLocationStatus.InTransit:
      return 'info';
    case ContainerLocationStatus.Overdue:
    case ContainerLocationStatus.OverdueError:
    case ContainerLocationStatus.OverdueNoCharge:
      return 'warning';
    case ContainerLocationStatus.OverdueSold:
      return 'warning';
    case ContainerLocationStatus.Lost:
    case ContainerLocationStatus.LostByStore:
      return 'danger';
    case ContainerLocationStatus.OnHold:
      return 'secondary';
    case ContainerLocationStatus.Broken:
    case ContainerLocationStatus.BrokenAtUser:
      return 'danger';
    case ContainerLocationStatus.Unknown:
    default:
      return 'dark';
  }
};

type ContainerLocationStatusBadgeProps = {
  status: ContainerLocationStatus;
  size?: 's' | 'm' | 'l';
};

const ContainerLocationStatusBadge = ({
  status,
  size = 'm',
}: ContainerLocationStatusBadgeProps) => {
  const getStatusText = () => {
    if (status === ContainerLocationStatus.Lost) {
      return i18n.t('Containers:statusLabelWithDescription', {
        status: ContainerLocationStatus[status],
      });
    }
    return ContainerLocationStatus[status];
  };

  const getSizeClass = () => {
    switch (size) {
      case 's':
        return 'fs-6';
      case 'l':
        return 'fs-5';
      default:
        return '';
    }
  };

  return (
    <>
      {i18n.t('Containers:statusLabel')}
      <Badge
        color={getContainerLocationStatusColor(status)}
        className={`border border-1 ${getSizeClass()}`}
        pill
      >
        {getStatusText()}
      </Badge>
    </>
  );
};

export default ContainerLocationStatusBadge;
